import { SsMount } from 'src/js/dom/mount.js';
import { throttle } from 'lodash';
import { SsThreadAccord } from 'src/js/dom/thread-accord.js';
import { isMobile } from 'src/js/lib/snif.js';

export class SsThreadHead extends SsMount {
  init () {
    this.clickID = throttle( this.clickLsn.bind( this ), 100 );
    return this;
  }

  setAccord ( elm ) {
    this.accord = new SsThreadAccord( elm );
    return this;
  }

  onClick () {
    this.$.on( 'click', this.clickID );
  }

  offClick () {
    this.$.off( 'click', this.clickID );
  }

  async clickLsn () {
    this.offClick();
    if ( isMobile() ) {
      await this.accord.toggle();
    }
    this.onClick();
  }
}
